__turbopack_context__.v({
  "content-section": "c6xbpW_content-section",
});
